<template>
  <div>
    <!-- Only show router-view for error paths -->
    <router-view v-if="$route.path === '/error-404' || $route.path === '/error-403'" />

    <!-- Show Super Admin layout for everything else -->
    <layout-super-admin v-else>
      <router-view />

      <template #navbar="{ toggleVerticalMenuActive }">
        <navbar :toggle-vertical-menu-active="toggleVerticalMenuActive" />
      </template>
    </layout-super-admin>
  </div>
</template>

<script>
import LayoutSuperAdmin from "@/@core/layouts/layout-super-admin/LayoutSuperAdmin.vue";
// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'
import Navbar from "./components/Navbar.vue";

export default {
  components: {
    // AppCustomizer,
    LayoutSuperAdmin,
    Navbar,
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    };
  },
};
</script>
